<script>
  import { _ } from "svelte-i18n";
  import { router } from "tinro";
  import { BASE_URL } from "../utilities/config.js";
  import { createEventDispatcher, onMount } from "svelte";
  import {
    userId,
    userName,
    assessmentType,
    assessmentId,
    assessmentState,
    finalScoreDetail,
    activationCode,
    assessmentDefinitionId,
    invitationNumber,
    currentPage,
    showCompletedSelection,
  } from "../utilities/DataStore";
  import { now } from "svelte/internal";
  import ResultReport from "./components/ResultReport.svelte";
  import ResultReportNoData from "./components/ResultReportNoData.svelte";
  import FeedbackModal from "./components/FeedbackModal.svelte";
  import ResultReportNtnu from "./components/ResultReportNtnu.svelte";
  import {
    submitFinalAssessmentResults,
    callEvaluationService,
  } from "./components/UploadResults.svelte";
    import ResultReportDetail from "./components/ResultReportDetail.svelte";
  import ResultReportIelts from "./components/ResultReportIelts.svelte";
  import ResultReportIeltsWriting from "./components/ResultReportIeltsWriting.svelte";
  import ResultReportIeltsSpeaking from "./components/ResultReportIeltsSpeaking.svelte";

  // IELTS report types, same map the admin app dispatches on: the skill picks
  // the band table and the wording of the report, the variant picks between
  // the score summary and the detailed feedback.
  const IELTS_REPORT_TYPES = {
    IELTS_READING: { skill: "READING", variant: "SCORE" },
    IELTS_READING_DETAIL: { skill: "READING", variant: "DETAIL" },
    IELTS_LISTENING: { skill: "LISTENING", variant: "SCORE" },
    IELTS_LISTENING_DETAIL: { skill: "LISTENING", variant: "DETAIL" },
    IELTS_WRITING: { skill: "WRITING", variant: "SCORE" },
    IELTS_WRITING_DETAIL: { skill: "WRITING", variant: "DETAIL" },
    IELTS_SPEAKING: { skill: "SPEAKING", variant: "SCORE" },
    IELTS_SPEAKING_DETAIL: { skill: "SPEAKING", variant: "DETAIL" },
  };

  $: ieltsReport = IELTS_REPORT_TYPES[definitionData?.reportType] || null;

  const dispatch = createEventDispatcher();
  onMount(async () => {
    initialize();
  });

  export let instanceId;

  let instanceData;
  let definitionData;
  let exerciseListStatus;
  let definitionStatus;
  let reviewCommentData;
  let completionCheckStatus = "NEW";
  let allSectionsCompleted = true;
  let redirectedIncompleteNoData = false;

  let errorMsg;

  const DONE_STATUSES = ["SCORED", "DONE", "SUBMITTED", "ENDED"];

  function initialize() {
    definitionStatus = "LOADING";
    exerciseListStatus = "LOADING";

    Promise.all([loadInstanceData()])
      .then(() => {})
      .catch(() => {
        console.log("reloading");
        setTimeout(function () {
          loadInstanceData();
        }, 1500);
      });
  }

  async function loadDefinitionData(assessmentDefinitionId) {
    definitionStatus = "LOADING";
    return fetch(
      BASE_URL + `/public/assessment/definition/` + assessmentDefinitionId,
    )
      .then((response) => {
        if (!response.ok) {
          console.error("response error");
          throw new Error("Network response was not ok");
        }
        console.log("response ok", response);
        return response.json();
      })
      .then((data) => {
        definitionData = data;
        console.log("definitionData", definitionData);
        definitionStatus = "OK";
        if (definitionData?.activationCode){
          $activationCode = definitionData?.activationCode;
        }
      })
      .catch((error) => {
        console.error("catch error", error);
        errorMsg = "ERROR_LOADING_ASSESSMENT";
        definitionData = undefined;
        definitionStatus = "ERROR";
      });
  }

  async function loadInstanceData() {
    exerciseListStatus = "LOADING";
    return fetch(BASE_URL + `/public/assessment/instance/` + instanceId)
      .then((response) => {
        if (!response.ok) {
          console.log("response error");
          throw new Error("Network response was not ok");
        }
        console.log("response ok", response);
        return response.json();
      })
      .then(async (data) => {
        instanceData = data;
        if (instanceData.reviewComment != null) {
          $finalScoreDetail = JSON.parse(instanceData.reviewComment);
        }

        if (instanceData.status === "NEW") {
          if (new Date() < Date.parse(instanceData?.deadlineAt + "Z")) {
            $assessmentDefinitionId = instanceData?.assessmentDefinitionId;
            $assessmentId = instanceData?.assessmentId;
            $userName = instanceData?.clientName;
            $userId = instanceData?.clientId;
            $currentPage = "AssessmentExercise";

            dispatch("resumeAssessment", {});
            // throw new Error("Assesment not yet scored");
          } else {
            console.error("EXPIRED - TODO");
            submitFinalResult()
            throw new Error("Assesment not yet scored - EXPIRED");
          }
        } else if (instanceData.status === "CANCEL" || instanceData.status === "EXPIRED") {
           $currentPage = "AssessmentSelection";
        } 
        
        else if (!["SCORED", "DONE", "SUBMITTED", "ENDED"].includes(instanceData.status)) {
          throw new Error("Assesment not yet scored - NOT SCORED");
        }

        console.log(
          Date.parse(instanceData?.createdAt) /
            Date.parse(instanceData?.deadlineAt),
        );
        console.log("instanceData", instanceData);
        exerciseListStatus = "OK";

        if (instanceData?.invitationNumber){
          $invitationNumber = instanceData?.invitationNumber;
          $userName = instanceData?.clientName;
          $userId = instanceData?.clientId;
        }

        await loadInvitationCompletionStatus(instanceData?.invitationNumber || $invitationNumber);

        loadDefinitionData(instanceData.assessmentDefinitionId);
      })
      .catch((error) => {
        console.log("catch error", error);
        errorMsg = "ERROR_LOADING_ASESSMENT_INSTANCE";
        instanceData = undefined;
        //exerciseListStatus = "ERROR";
        setTimeout(function () {
          loadInstanceData();
        }, 10000);
        // throw new Error("Some Error, try again");
      });
  }

  async function loadInvitationCompletionStatus(invNum) {
    if (!invNum) {
      // Non-invitation flows can continue to existing behavior.
      allSectionsCompleted = true;
      completionCheckStatus = "OK";
      return;
    }

    completionCheckStatus = "LOADING";
    try {
      const sections = await fetch(
        BASE_URL + `/public/assessment/invitation/${invNum}/definitions-detail`,
      ).then((response) => {
        if (!response.ok) {
          throw new Error("Failed to load invitation definitions-detail");
        }
        return response.json();
      });

      const total = (sections || []).length;
      const done = (sections || []).filter((s) =>
        DONE_STATUSES.includes(s.invDefStatus) ||
        DONE_STATUSES.includes(s.status) ||
        s.invDefStatus === "CANCEL" ||
        s.invDefStatus === "EXPIRED",
      ).length;

      allSectionsCompleted = total > 0 && done === total;
    } catch (error) {
      console.error("loadInvitationCompletionStatus error", error);
      allSectionsCompleted = false;
    } finally {
      completionCheckStatus = "OK";
    }
  }

  $: if (
    !redirectedIncompleteNoData &&
    definitionData &&
    completionCheckStatus === "OK" &&
    ["NO_DATA", "TO_START"].includes(definitionData?.reportType) &&
    !allSectionsCompleted
  ) {
    redirectedIncompleteNoData = true;
    // Keep user on selection page to continue remaining sections.
    $showCompletedSelection = false;
    router.goto("/");
    $currentPage = "AssessmentSelection";
  }

  function submitFinalResult() {
    console.log("submitFinalResults");
    // submitFinalAssessmentResultsStatus = "LOADING";
    submitFinalAssessmentResults(instanceId).then(async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      callEvaluationService($assessmentDefinitionId, instanceId).then(
        (data) => {
          $assessmentState = "DONE";
          $currentPage = "AssessmentResults";
          $finalScoreDetail = data;
          router.goto('/certificate/'+instanceId);
        }
      );
    });
  }
</script>

<div class="container">
  <div class="row align-items-center" style="display: none;">
    <div class="col">
      <div class="lesson-title">
        {$assessmentType}
      </div>
    </div>
    <div class="col-auto lesson-detail-box">
      <div class="lesson-detail float-right">
        <div>Assessment: {$assessmentId}</div>
        <div>Instance: {instanceId}</div>
        <div>userName: {$userName}</div>
        <div>UserId: {$userId}</div>
        <div>State: {$assessmentState}</div>
      </div>
    </div>
  </div>

  <div class="card-group">
    {#if exerciseListStatus === "NEW"}
      Loading
    {:else if exerciseListStatus === "LOADING" || definitionStatus === "LOADING"}
      Loading
    {:else if exerciseListStatus === "ERROR" || definitionStatus === "ERROR"}
      Error loading lesson
    {:else if instanceData && definitionData}
      {#if definitionData?.reportType === "NTNU"}
        <ResultReportNtnu {instanceId} {instanceData} />
      {:else if definitionData?.reportType === "NO_DATA"}
        {#if completionCheckStatus === "OK" && allSectionsCompleted}
          <ResultReportNoData {instanceId} {instanceData} />
        {:else}
          Loading
        {/if}
      {:else if definitionData?.reportType === "TO_START"}
        {#if completionCheckStatus === "OK" && allSectionsCompleted}
          <ResultReportNoData {instanceId} {instanceData} />
        {:else}
          Loading
        {/if}
      {:else if definitionData?.reportType === "FEEDBACK"}
        <ResultReport {instanceId} {instanceData} />
        <FeedbackModal />
      {:else if definitionData?.reportType === "SCORE_REPORT"}
        <ResultReportDetail {instanceId} {instanceData} />
      {:else if ieltsReport?.skill === "READING" || ieltsReport?.skill === "LISTENING"}
        <ResultReportIelts
          {instanceId}
          {instanceData}
          skill={ieltsReport.skill}
          variant={ieltsReport.variant}
        />
      {:else if ieltsReport?.skill === "WRITING"}
        <ResultReportIeltsWriting
          {instanceId}
          {instanceData}
          variant={ieltsReport.variant}
        />
      {:else if ieltsReport?.skill === "SPEAKING"}
        <ResultReportIeltsSpeaking
          {instanceId}
          {instanceData}
          variant={ieltsReport.variant}
        />
      {:else}
        <ResultReport {instanceId} {instanceData} />
      {/if}
    {:else}
      xyz
    {/if}
  </div>
</div>

<style>
  @media (max-width: 768px) {
    .lesson-detail-box {
      display: none;
    }
    .container {
      padding: 0;
    }
  }

  .card-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .lesson-title {
    font-weight: 600;
    font-size: large;
  }

  .lesson-detail {
    border: 1px;
    border-color: #9d9fa2;
    border-style: solid;
    border-radius: 5px;
    margin: 0.5em;
    padding: 0.5em;
  }
</style>
